// function parseOSAndDeviceModel(ua: string) {
//     ua = ua.toLowerCase();

//     // iOS example
//     const iosMatch = ua.match(/iphone os ([\d_]+)/);
//     if (iosMatch) {
//         const osVersion = iosMatch[1].replace(/_/g, '.');
//         return { osVersion: `iOS ${osVersion}`, deviceModel: 'iPhone' };
//     }

//     // Android example
//     const androidMatch = ua.match(/android ([\\d.]+);? ?([a-z0-9 ]+build)?/);
//     if (androidMatch) {
//         const osVersion = androidMatch[1];
//         const deviceModel = androidMatch[2] ? androidMatch[2].trim() : 'Android Device';
//         return { osVersion: `Android ${osVersion}`, deviceModel };
//     }

//     return { osVersion: 'Unknown OS', deviceModel: 'Unknown Device' };
// }

async function getPublicIP(): Promise<string> {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip as string;
  } catch {
    return "unknown_ip";
  }
}

export async function generateNormalizedWebFingerprint(
  platform: string,
): Promise<{
  ip: string;
  platform: string;
  timezone: string;
  screenResolution: string;
  hashHex: string;
}> {
  // const language = (navigator.language || "en-us").toLowerCase();
  const tzMinutes = new Date().getTimezoneOffset();
  const tzSign = tzMinutes <= 0 ? "+" : "-";
  const tzAbs = Math.abs(tzMinutes);
  const tzHours = Math.floor(tzAbs / 60);
  const tzRemainderMinutes = tzAbs % 60;
  // Represent half-hour zones as .5 (e.g., +5.5), otherwise just +7 style
  const timezone = `${tzSign}${tzRemainderMinutes === 0 ? tzHours : tzRemainderMinutes === 30 ? `${tzHours}.5` : tzHours}`;
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const ip = await getPublicIP();

  const fingerprintString = [ip, platform, timezone, screenResolution].join(
    "|",
  );

  const encoder = new TextEncoder();
  const data = encoder.encode(fingerprintString);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return { ip, platform, timezone, screenResolution, hashHex };
}
